import documentToReactComponentsFactory from './document-to-react-components-factory'
import standardOptions from './document-to-react-component-renderers/standard'

const documentToReactComponents = documentToReactComponentsFactory(standardOptions)

export default documentToReactComponents
